// extracted by css-extract-rspack-plugin
export default {"placeholderOverlay":"_1699ca6a","rotatingTerm":"_ceed9961","fadeSlideUp":"_b26194c7","fadeSlideIn":"_6649d505"};